import React from 'react'

import { UikLayoutMain } from 'components'
import cls from '../PartnerPortal.module.scss'

const PartnerPortalPage = ({ children }) => (
  <>
    <UikLayoutMain className={cls.partnerPortalPage}>{children}</UikLayoutMain>
    <div className={cls.bottomNavGap} />
  </>
)

export default PartnerPortalPage
